import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
} from "@angular/core";
import IUserSkill from "../../../models/userSkills";
import { Subscription } from "rxjs";
import { AppState } from "@skills-app/root.reducer";
import { Store } from "@ngrx/store";
import * as fromTeamReducer from "@skills-app/build-team/reducers/build-team.reducer";
import { BuildTeamPageActions } from "../../../build-team/actions";

@Component({
  standalone: false,
  selector: "app-team-toggle-button",
  templateUrl: "./team-toggle-button.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./team-toggle-button.component.css"],
})
export class TeamToggleButtonComponent implements OnInit, OnDestroy, OnChanges {
  @Input() consultant!: IUserSkill;

  teamSubscription?: Subscription;
  teamMembers: IUserSkill[] = [];

  // Cached UI state to avoid template function churn
  public isInTeamCached = false;
  public buttonTextCached = "+";

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.teamSubscription = this.store
      .select(fromTeamReducer.getTeamMembers)
      .subscribe((results) => {
        this.teamMembers = results ?? [];
        this.recomputeCachedState();
      });

    // In case consultant input already set before subscription emits
    this.recomputeCachedState();
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.recomputeCachedState();
  }

  ngOnDestroy(): void {
    this.teamSubscription?.unsubscribe();
  }

  private recomputeCachedState(): void {
    const consultant = this.consultant;
    const members = this.teamMembers ?? [];

    const inTeam = !!consultant && members.includes(consultant);
    this.isInTeamCached = inTeam;
    this.buttonTextCached = inTeam ? "-" : "+";
  }

  toggleTeamMembership(): void {
    if (this.teamMembers.includes(this.consultant)) {
      this.store.dispatch(
        BuildTeamPageActions.removeFromTeam({ userSkill: this.consultant }),
      );
    } else {
      this.store.dispatch(
        BuildTeamPageActions.addToTeam({ userSkills: [this.consultant] }),
      );
    }
  }
}
